import { useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { es } from "date-fns/locale";

const fmt = (iso) => iso ? new Date(iso + "T00:00:00").toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" }) : "";
const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function DateCell({ value, onChange, disabled, testid, placeholder = "Fecha…", className }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <Popover open={open} onOpenChange={(v) => !disabled && setOpen(v)}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testid} aria-label={value ? `Fecha: ${fmt(value)}` : (placeholder || "Elegir fecha")}
          className={cn("h-8 w-full inline-flex items-center gap-1.5 rounded-md border border-transparent hover:border-slate-300 px-2 text-sm text-left transition-colors focus:outline-none focus:border-primary disabled:opacity-60 disabled:cursor-default", !value && "text-muted-foreground", className)}>
          <CalendarIcon className="h-3.5 w-3.5 shrink-0 opacity-60" />
          <span className="truncate">{value ? fmt(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={es} selected={selected} defaultMonth={selected}
          onSelect={(d) => { onChange(d ? toISO(d) : null); setOpen(false); }} />
        {value && (
          <div className="border-t border-border p-2 text-center">
            <button type="button" className="text-xs text-muted-foreground hover:text-destructive" onClick={() => { onChange(null); setOpen(false); }} data-testid={testid ? `${testid}-clear` : undefined}>Quitar fecha</button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
